import { createApiAction } from 'src/api';
import dayjs from 'dayjs';
import { DEFAULT_DATE_FORMAT } from 'src/ui/const';

export const UPDATE_ACCOUNT_PAYMENT_START =
  'account/update_account_payment_start';
export const UPDATE_ACCOUNT_PAYMENT_SUCCESS =
  'account/update_account_payment_success';
export const UPDATE_ACCOUNT_PAYMENT_FAILURE =
  'account/update_account_payment_failure';

export const ADD_PAYMENT_PRICE_START = 'account/add_payment_price_start';
export const ADD_PAYMENT_PRICE_SUCCESS = 'account/add_payment_price_success';
export const ADD_PAYMENT_PRICE_FAILURE = 'account/add_payment_price_failure';

export const UPDATE_PAYMENT_PRICE_START = 'account/update_payment_price_start';
export const UPDATE_PAYMENT_PRICE_SUCCESS =
  'account/update_payment_price_success';
export const UPDATE_PAYMENT_PRICE_FAILURE =
  'account/update_payment_price_failure';

export const DELETE_PAYMENT_PRICE_START = 'account/delete_payment_price_start';
export const DELETE_PAYMENT_PRICE_SUCCESS =
  'account/delete_payment_price_success';
export const DELETE_PAYMENT_PRICE_FAILURE =
  'account/delete_payment_price_failure';

export const updateAccountPayment = ({
  accountId,
  accountBankName,
  accountNameOnAccount,
  accountRoutingNumber,
  accountAccountNumber,
  accountBankAddress,
  accountBankPhoneNumber,
  terminalModel1,
  terminalModel2,
  terminalModel3,
  terminalQuantity1,
  terminalQuantity2,
  terminalQuantity3,
  terminalVersion1,
  terminalVersion2,
  terminalVersion3,
  terminalPrice1,
  terminalPrice2,
  terminalPrice3,
  acceptedCardBefore,
  processorName,
  priorTerminations,
  priorTerminationsExplanation,
  numberOfLocations,
  existingMid,
  annualVolume,
  monthlyVolume,
  avgTicket,
  highTicket,
  pricingFormat,
  processingType,
  pinBasedDebitRate,
  chargeBackFee,
  salesTrxFee,
  monthlyMinimumFee,
  pciMonthlyProgramFee,
  retrievalFee,
  returnFee,
  batchCloseFee,
  terminalIdFee,
  monthlyStatementFee,
  onlinePortalFee,
  pciNonComplianceFee,
  achRejectFee,
  processingStartDate,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/payments/`,
      method: 'PUT',
      body: {
        // bank information tab
        account_settlement_account_bank_name: accountBankName,
        account_settlement_account_business_name_on_checks: accountNameOnAccount,
        account_settlement_account_routing_number: accountRoutingNumber,
        account_settlement_account_account_number: accountAccountNumber,
        account_settlement_account_bank_address: accountBankAddress,
        account_settlement_account_bank_phone_number: accountBankPhoneNumber,
        // card processing information
        account_accepted_card_before: acceptedCardBefore,
        account_processor_name: processorName,
        account_prior_terminations: priorTerminations,
        account_prior_terminations_explanation: priorTerminationsExplanation,
        account_number_of_locations: numberOfLocations,
        account_existing_mid: existingMid,
        account_annual_volume: annualVolume,
        account_monthly_volume: monthlyVolume,
        account_avg_ticket: avgTicket,
        account_high_ticket: highTicket,
        account_estimated_processing_start_date: processingStartDate
          ? dayjs(processingStartDate).format(DEFAULT_DATE_FORMAT)
          : null,
        // new payment fields
        account_pricing_format: pricingFormat,
        account_processing_type: processingType,
        account_pin_based_debit_rate: pinBasedDebitRate,
        account_chargeback_fee: chargeBackFee,
        account_sales_trx_fee: salesTrxFee,
        account_monthly_minimum_fee: monthlyMinimumFee,
        account_pci_monthly_program_fee: pciMonthlyProgramFee,
        account_retrieval_fee: retrievalFee,
        account_return_fee: returnFee,
        account_batch_close_fee: batchCloseFee,
        account_terminal_id_fee: terminalIdFee,
        account_monthly_statement_fee: monthlyStatementFee,
        account_online_portal_fee: onlinePortalFee,
        account_pci_non_compliance_fee: pciNonComplianceFee,
        account_ach_reject_fee: achRejectFee,
        // new equipment fields
        account_terminal_model_1: terminalModel1,
        account_terminal_model_2: terminalModel2,
        account_terminal_model_3: terminalModel3,
        account_terminal_qty_1: terminalQuantity1,
        account_terminal_qty_2: terminalQuantity2,
        account_terminal_qty_3: terminalQuantity3,
        account_terminal_version_1: terminalVersion1,
        account_terminal_version_2: terminalVersion2,
        account_terminal_version_3: terminalVersion3,
        account_terminal_price_1: terminalPrice1,
        account_terminal_price_2: terminalPrice2,
        account_terminal_price_3: terminalPrice3,
      },
    },
    [
      UPDATE_ACCOUNT_PAYMENT_START,
      UPDATE_ACCOUNT_PAYMENT_SUCCESS,
      UPDATE_ACCOUNT_PAYMENT_FAILURE,
    ]
  );

export const updateAccountPaymentOverview = ({
  accountId,
  initials,
  cardPresentRetail,
  cardNotPresentEcommerce,
  mailTelephoneOrdering,
  currentlyOfferingCardPresentRetail,
  currentlyOfferingCardNotPresentEcommerce,
  currentlyOfferingMailTelephoneOrdering,
  hasPosPartner,
  posPartner,
  hasShoppingCartVendor,
  shoppingCartVendor,
  percentageSalesNonUsCards,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/payments_overview/`,
      method: 'PUT',
      body: {
        initials,
        account_card_present_retail: cardPresentRetail,
        account_card_not_present_ecommerce: cardNotPresentEcommerce,
        account_mail_telephone_ordering: mailTelephoneOrdering,
        account_currently_offering_card_present_retail: currentlyOfferingCardPresentRetail,
        account_currently_offering_card_not_present_ecommerce: currentlyOfferingCardNotPresentEcommerce,
        account_currently_offering_mail_telephone_ordering: currentlyOfferingMailTelephoneOrdering,
        account_has_pos_partner: hasPosPartner,
        account_pos_partner: posPartner,
        account_has_shopping_cart_vendor: hasShoppingCartVendor,
        account_shopping_cart_vendor: shoppingCartVendor,
        account_percentage_sales_non_us_cards: percentageSalesNonUsCards,
      },
    },
    [
      UPDATE_ACCOUNT_PAYMENT_START,
      UPDATE_ACCOUNT_PAYMENT_SUCCESS,
      UPDATE_ACCOUNT_PAYMENT_FAILURE,
    ]
  );

export const addAccountPaymentPrice = ({
  financialInstitutionId,
  accountId,
  prices,
}) => {
  const data = prices.map(p => ({
    payment_price_payment_product: p.paymentProductId,
    payment_price_fixed_fee: p.fixedFee,
    payment_price_percentage_fee: p.percentageFee,
  }));

  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/accounts/${accountId}/payment_prices/`,
      method: 'POST',
      body: data,
    },
    [
      ADD_PAYMENT_PRICE_START,
      ADD_PAYMENT_PRICE_SUCCESS,
      ADD_PAYMENT_PRICE_FAILURE,
    ]
  );
};

export const updateAccountPaymentPrice = ({
  financialInstitutionId,
  accountId,
  paymentPriceId,
  paymentProductId,
  fixedFee,
  percentageFee,
}) =>
  createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/accounts/${accountId}/payment_prices/${paymentPriceId}/`,
      method: 'PUT',
      body: {
        payment_price_payment_product: paymentProductId,
        payment_price_fixed_fee: fixedFee,
        payment_price_percentage_fee: percentageFee,
      },
    },
    [
      UPDATE_PAYMENT_PRICE_START,
      UPDATE_PAYMENT_PRICE_SUCCESS,
      UPDATE_PAYMENT_PRICE_FAILURE,
    ]
  );

export const deleteAccountPaymentPrice = ({
  financialInstitutionId,
  accountId,
  paymentPriceId,
}) => {
  return createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/accounts/${accountId}/payment_prices/${paymentPriceId}/`,
      method: 'DELETE',
    },
    [
      DELETE_PAYMENT_PRICE_START,
      DELETE_PAYMENT_PRICE_SUCCESS,
      DELETE_PAYMENT_PRICE_FAILURE,
    ]
  );
};
